import { useTranslation } from 'libs/i18n';

import {
  IdentificationNumbersFormType,
  FormErrors,
  getSchema,
} from '../../forms/identificationNumbersForm';
import { ClientType, FormBodyWrapper } from '../FormBodyWrapper';

import { FormContent } from './FormContent';

interface Props {
  initialValues?: IdentificationNumbersFormType;
  onSubmit: (values: IdentificationNumbersFormType) => void;
  canGoBack?: boolean;
  onGoBack?: () => void;
  formError?: FormErrors;
  submitLoading?: boolean;
  clientType?: ClientType;
  subTitle?: string;
}

export const IdentificationNumbers = ({
  initialValues,
  canGoBack,
  submitLoading,
  formError,
  onGoBack,
  onSubmit,
  clientType,
  subTitle,
}: Props) => {
  const { t } = useTranslation();
  const schema = getSchema();
  return (
    <FormBodyWrapper
      canGoBack={canGoBack}
      clientType={clientType}
      initialErrors={formError}
      initialValues={initialValues}
      submitLoading={submitLoading}
      subTitle={subTitle ?? t('onboarding.identificationNumbers.subtitle')}
      title={t('onboarding.identificationNumbers.title')}
      validationSchema={schema}
      onGoBack={onGoBack}
      onSubmit={onSubmit}
    >
      <FormContent />
    </FormBodyWrapper>
  );
};
